/* Alpe PDP · USP bar (marquee) in slider Klaviyo mnenj. Claude, 2026-09-24. */
(() => {
  if (window.AlpePdpExtras) return;
  window.AlpePdpExtras = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- USP bar: neskončno, počasno pomikanje od desne proti levi ---------- */
  const initUsp = root => {
    if (root._alpeUsp) return;
    root._alpeUsp = true;
    const track = root.querySelector('[data-alpe-usp-track]');
    const base = root.querySelector('[data-alpe-usp-set]');
    const viewport = root.querySelector('.alpe-pdp-usp__viewport');
    if (!track || !base || !viewport) return;
    const speed = Math.max(5, Number(root.dataset.speed) || 26);
    let lastKey = '';
    const layout = () => {
      const setWidth = base.getBoundingClientRect().width;
      const vw = viewport.getBoundingClientRect().width;
      const key = `${Math.round(setWidth)}:${Math.round(vw)}`;
      if (!setWidth || key === lastKey) return;
      lastKey = key;
      track.querySelectorAll('[data-alpe-usp-clone]').forEach(n => n.remove());
      const copies = Math.max(1, Math.ceil(vw / setWidth)) + 1;
      for (let i = 0; i < copies; i++) {
        const clone = base.cloneNode(true);
        clone.removeAttribute('data-alpe-usp-set');
        clone.setAttribute('data-alpe-usp-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      }
      track.style.setProperty('--alpe-usp-shift', `${setWidth}px`);
      track.style.setProperty('--alpe-usp-duration', `${(setWidth / speed).toFixed(2)}s`);
      root.classList.add('is-ready');
    };
    layout();
    if ('ResizeObserver' in window) new ResizeObserver(layout).observe(base);
    window.addEventListener('resize', layout, { passive: true });
    // Pavza, ko je bar izven zaslona (manj dela za brskalnik).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => entries.forEach(e => root.classList.toggle('is-offscreen', !e.isIntersecting))).observe(root);
    }
  };

  /* ---------- Slider mnenj: Klaviyo mnenja odprtega izdelka ---------- */
  const API = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/';
  const MEDIA = 'https://reviews-media.services.klaviyo.com/abc/width:{w}/height:{w}/resizing_type:fill/plain/https://klaviyo.s3.amazonaws.com/reviews/images/';
  const CACHE_MS = 30 * 60 * 1000;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cacheGet = key => { try { const v = JSON.parse(sessionStorage.getItem(key) || 'null'); return v && Date.now() - v.t < CACHE_MS ? v.d : null; } catch (e) { return null; } };
  const cacheSet = (key, d) => { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d })); } catch (e) {} };

  const loadReviews = async (productId, companyId) => {
    const key = `alpe-kl-reviews:${companyId}:${productId}`;
    const cached = cacheGet(key);
    if (cached) return cached;
    const q = `company_id=${encodeURIComponent(companyId)}`;
    let groupId = productId;
    try {
      const g = await fetch(`${API}${productId}/grouped_id/?${q}`, { credentials: 'omit' }).then(r => r.ok ? r.json() : null);
      if (g && g.grouped_id) groupId = g.grouped_id;
    } catch (e) {}
    const params = new URLSearchParams({ product_id: productId, company_id: companyId, limit: '20', offset: '0', sort: '3', filter: '', type: 'reviews', media: 'false', kl_review_uuid: '', preferred_country: 'SI', tz: 'Europe/Ljubljana' });
    const res = await fetch(`${API}${groupId}/?${params}`, { credentials: 'omit' });
    if (!res.ok) throw new Error(`Klaviyo ${res.status}`);
    const data = await res.json();
    const list = (data.reviews || [])
      .filter(r => (r.type || 'review') === 'review' && String(r.content || r.smart_quote || '').trim())
      .map(r => {
        const img = r.image_uuid || (Array.isArray(r.images) && r.images[0] && (r.images[0].uuid || r.images[0])) || '';
        return { author: String(r.author || '').trim(), rating: Math.max(0, Math.min(5, Number(r.rating) || 0)), text: String(r.content || r.smart_quote).replace(/\s+/g, ' ').trim(), image: typeof img === 'string' ? img : '' };
      });
    // Mnenja s fotografijo najprej, nato ostala v Klaviyo vrstnem redu.
    const sorted = [...list.filter(r => r.image), ...list.filter(r => !r.image)].slice(0, 12);
    cacheSet(key, sorted);
    return sorted;
  };

  const slideHtml = (r, i, n) => {
    const stars = '&#9733;&#9733;&#9733;&#9733;&#9733;';
    const media = r.image ? `<span class="alpe-pdp-reviews__media"><img src="${MEDIA.replace(/{w}/g, 220)}${esc(r.image)}" srcset="${MEDIA.replace(/{w}/g, 110)}${esc(r.image)} 1x, ${MEDIA.replace(/{w}/g, 220)}${esc(r.image)} 2x, ${MEDIA.replace(/{w}/g, 330)}${esc(r.image)} 3x" alt="Fotografija kupca ${esc(r.author)}" width="104" height="104" loading="lazy" decoding="async"></span>` : '';
    return `<a class="alpe-pdp-reviews__slide${r.image ? '' : ' alpe-pdp-reviews__slide--text'}" href="#alpe-klaviyo-reviews" data-alpe-review-link role="group" aria-roledescription="slide" aria-label="Mnenje ${i + 1} od ${n}" draggable="false">
      ${media}
      <span class="alpe-pdp-reviews__body">
        <span class="alpe-pdp-reviews__meta">
          <span class="alpe-pdp-reviews__author">${esc(r.author)}</span>
          <span class="alpe-pdp-reviews__stars" role="img" aria-label="Ocena ${r.rating} od 5"><span class="alpe-pdp-reviews__stars-empty" aria-hidden="true">${stars}</span><span class="alpe-pdp-reviews__stars-filled" aria-hidden="true" style="width:${(r.rating / 5) * 100}%">${stars}</span></span>
        </span>
        <span class="alpe-pdp-reviews__text">${esc(r.text)}</span>
      </span>
    </a>`;
  };

  const initReviews = async root => {
    if (root._alpeReviews) return;
    root._alpeReviews = true;
    const viewport = root.querySelector('[data-alpe-review-viewport]');
    const prev = root.querySelector('[data-alpe-review-prev]');
    const next = root.querySelector('[data-alpe-review-next]');
    let reviews = [];
    try { reviews = await loadReviews(root.dataset.productId, root.dataset.companyId); } catch (e) { reviews = []; }
    if (!reviews.length) { root.hidden = true; return; }
    const n = reviews.length;
    viewport.innerHTML = reviews.map((r, i) => slideHtml(r, i, n)).join('');
    const slides = [...viewport.children];
    let index = 0, busy = false, timer = null, hovering = false, focused = false, visible = true;
    slides.forEach((s, i) => { s.classList.toggle('is-active', i === 0); s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true'); if (i) s.setAttribute('tabindex', '-1'); });
    root.hidden = false;
    root.classList.toggle('is-single', n < 2);
    prev.disabled = next.disabled = n < 2;

    const go = (to, dir) => {
      if (busy || n < 2) return;
      const target = (to + n) % n;
      if (target === index) return;
      const from = slides[index], into = slides[target];
      const instant = reduced.matches;
      busy = !instant;
      into.classList.remove('is-leaving-left', 'is-leaving-right');
      into.classList.add(dir > 0 ? 'is-from-right' : 'is-from-left');
      void into.offsetWidth;
      into.classList.add('is-active');
      into.classList.remove('is-from-right', 'is-from-left');
      from.classList.remove('is-active');
      from.classList.add(dir > 0 ? 'is-leaving-left' : 'is-leaving-right');
      from.setAttribute('aria-hidden', 'true'); from.setAttribute('tabindex', '-1');
      into.setAttribute('aria-hidden', 'false'); into.removeAttribute('tabindex');
      index = target;
      const done = () => { from.classList.remove('is-leaving-left', 'is-leaving-right'); busy = false; };
      if (instant) done(); else setTimeout(done, 650);
    };
    const delay = Number(root.dataset.autoplay) * 1000;
    const canPlay = () => delay > 0 && n > 1 && !reduced.matches && !hovering && !focused && visible && !document.hidden;
    const schedule = () => { clearTimeout(timer); if (canPlay()) timer = setTimeout(() => { go(index + 1, 1); schedule(); }, delay); };
    viewport.setAttribute('aria-live', delay > 0 ? 'off' : 'polite');

    prev.addEventListener('click', () => { go(index - 1, -1); schedule(); });
    next.addEventListener('click', () => { go(index + 1, 1); schedule(); });
    root.addEventListener('mouseenter', () => { hovering = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; clearTimeout(timer); });
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => entries.forEach(e => { visible = e.isIntersecting; schedule(); })).observe(root);
    root.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, -1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, 1); } });

    // Poteg s prstom / miško; klik po potegu ne odpre povezave.
    let startX = 0, startY = 0, dragging = false, swiped = false;
    viewport.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && e.button !== 0) return; startX = e.clientX; startY = e.clientY; dragging = true; swiped = false; });
    viewport.addEventListener('pointerup', e => {
      if (!dragging) return; dragging = false;
      const dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { swiped = true; go(index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); schedule(); }
    });
    viewport.addEventListener('pointercancel', () => { dragging = false; });
    root._alpeSwipedAt = () => swiped;
    root._alpeClearSwipe = () => { swiped = false; };
    schedule();
  };

  // Klik, ki sledi potegu, ne sme odpreti povezave do mnenj (window capture je pred ostalimi poslušalci).
  window.addEventListener('click', e => {
    const root = e.target instanceof Element && e.target.closest('[data-alpe-review-slider]');
    if (root && root._alpeSwipedAt && root._alpeSwipedAt()) { e.preventDefault(); e.stopImmediatePropagation(); root._alpeClearSwipe(); }
  }, true);

  const init = (scope = document) => {
    scope.querySelectorAll('[data-alpe-usp]').forEach(initUsp);
    scope.querySelectorAll('[data-alpe-review-slider]').forEach(root => { initReviews(root); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
